export default __webpack_public_path__ + "static/media/speed_fast_icon_bold.bfc82183.svg";